import { useState } from 'react'
import { Input } from '@/Components/Form/Inputs'
import { PeopleIcon } from '@/Components/UI/Icons'

interface GuestCountInputProps {
  initialValue?: number | ''
  onChange: (value: number | '') => void
}

const GuestCountInput = ({ initialValue = '', onChange }: GuestCountInputProps) => {
  const [numGuests, setNumGuests] = useState<number | ''>(initialValue)

  const handleChange = (value: number | '') => {
    setNumGuests(value)
    onChange(value)
  }

  return (
    <div className='flex flex-col gap-2'>
      <label
        htmlFor='duplicate-num-guests'
        className='!font-bold text-sm sm:text-base text-black leading-6'>
        Who&apos;s Invited? <span className='text-[#af231c]'>*</span>
      </label>
      <div className='relative flex w-[146px]' style={{ height: 'calc(1.5em + 18px)' }}>
        <PeopleIcon
          width={16}
          height={16}
          className='absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 shrink-0 pointer-events-none'
          style={{ color: '#BFBFBF' }}
        />
        <Input
          id='duplicate-num-guests'
          type='number'
          min='1'
          max='1000000'
          step='1'
          value={numGuests}
          onChange={({ target }) => handleChange(target.value ? parseInt(target.value, 10) : '')}
          placeholder='0'
          style={{
            paddingLeft: '2.25rem',
            borderColor: '#BFBFBF',
            color: '#262626',
            fontWeight: 'normal',
          }}
        />
      </div>
    </div>
  )
}

export default GuestCountInput
